import { type RootState } from '../rmsStore'

export default function getConfigureNotificationReducer (state: RootState) {
    return state.configureNotificationReducer
  }